import { render, staticRenderFns } from "./CourseConsumed.vue?vue&type=template&id=be468d6a&scoped=true"
import script from "./CourseConsumed.vue?vue&type=script&lang=js"
export * from "./CourseConsumed.vue?vue&type=script&lang=js"
import style0 from "./CourseConsumed.vue?vue&type=style&index=0&id=be468d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be468d6a",
  null
  
)

export default component.exports